import { Role, TelephoneNumber } from '@cco/model';
import { ModelObject } from './model-object';
import { User } from './auth/user';

export type DesiredDeliveryMedium = 'SMS' | 'EMAIL';
export type CredentialsDeliveryMedium = DesiredDeliveryMedium | 'CONSOLE';

export interface SmsConsent {
  phoneNumber: string;
  timestamp: string;
  recordedBy: string;
}

export function isCognitoUser(user: User): user is CognitoUser {
  return 'cognitoUsername' in user;
}

export interface CognitoUser extends ModelObject<string>, User {
  tenantId: number;
  userPoolId: string;
  cognitoUsername: string;
  sub?: string;
  preferredUsername: string;
  givenName: string;
  familyName: string;
  email: string;
  emailVerified: boolean;
  telephoneNumber: TelephoneNumber;
  phoneNumberVerified: boolean;
  roles: Role[];
  enabled: boolean;
  status: string;
  expiryDate: string;
  creationDate: string;
  lastModifiedDate: string;
  opaqueTenantCode?: string;
  credentialsDeliveryMedium?: CredentialsDeliveryMedium;
  smsConsent?: SmsConsent;
  previouslyConfirmed?: boolean;
}

export interface ResendInvitationRequest {
  credentialsDeliveryMedium: CredentialsDeliveryMedium;
}

export interface ResetPasswordRequest {
  credentialsDeliveryMedium: CredentialsDeliveryMedium;
}
